var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkhoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111}.cls-2{fill:#00c569}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11 22.5v-9.18A8.21 8.21 0 0 1 18.48 5 8 8 0 0 1 27 13v8H5.85A5.85 5.85 0 0 0 0 26.85v17.3A5.85 5.85 0 0 0 5.85 50h26.3A5.85 5.85 0 0 0 38 44.15v-17.3A5.85 5.85 0 0 0 32.15 21H32v-8A13 13 0 0 0 18.41 0 13.27 13.27 0 0 0 6 13.4v9.1m27 21.65a.85.85 0 0 1-.85.85H5.85a.85.85 0 0 1-.85-.85v-17.3a.85.85 0 0 1 .85-.85h26.3a.85.85 0 0 1 .85.85z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.5,
    y: 31,
    width: 5,
    height: 9,
    rx: 2.5,
    ry: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkhoa);
export default __webpack_public_path__ + "static/media/okhoa.b4682bf3b9c3ef782d45d595b7567efe.svg";
export { ForwardRef as ReactComponent };